import { createAction, props } from '@ngrx/store';
import {
  RetrieveSearchData,
  RetrieveSearchMcResponse,
  RetrieveSearchOwRtResponse
} from '../../models/core-apis/retrieve-search.interfaces';

enum RetrieveSearchActionTypes {
  storeRetrieveSearchInputValues = '[flight-shop book widget] retrieve search store input values',
  loadRetrieveSearch = '[flight-shop book widget] load retrieve search',
  loadRetrieveSearchSuccess = '[flight-shop book widget] load retrieve search success',
  loadRetrieveSearchFailure = '[flight-shop book widget] load retrieve search failure',
  loadOwRtRetrieveSearch = '[flight-shop book widget] load ow rt retrieve search',
  loadMcRetrieveSearch = '[flight-shop book widget] load mc retrieve search'
}

export const StoreRetrieveSearchInputValues = createAction(
  RetrieveSearchActionTypes.storeRetrieveSearchInputValues,
  props<{
    triggerRetrieveSearchLanding: boolean;
    retrieveSearchMcCacheKey: string;
    retrieveSearchOwRtResponse: RetrieveSearchOwRtResponse[] | null;
    retrieveSearchMcResponse: RetrieveSearchMcResponse | null;
  }>()
);

export const LoadRetrieveSearch = createAction(
  RetrieveSearchActionTypes.loadRetrieveSearch
);

export const LoadOwRtRetrieveSearch = createAction(
  RetrieveSearchActionTypes.loadOwRtRetrieveSearch
);

export const LoadMcRetrieveSearch = createAction(
  RetrieveSearchActionTypes.loadMcRetrieveSearch
);

export const LoadRetrieveSearchSuccess = createAction(
  RetrieveSearchActionTypes.loadRetrieveSearchSuccess,
  props<{ retrieveSearchDataList: RetrieveSearchData[] }>()
);

export const LoadRetrieveSearchFailure = createAction(
  RetrieveSearchActionTypes.loadRetrieveSearchFailure
);
